/** data-seatmap-tour attribute values used as step anchors */
export const SEATMAP_TOUR_TARGETS = {
  tabs: 'tabs',
  sidebar: 'sidebar',
  map: 'map',
  toolbar: 'toolbar',
  zoom: 'zoom',
  navActions: 'nav-actions',
}

export const SEATMAP_TUTORIAL_STORAGE_KEY = 'admin-seatmap-tutorial-v1'

export function getSeatmapTutorialSteps() {
  return [
    {
      id: 'welcome',
      title: 'Seat map guide',
      body: 'This short tour covers Scaling and Inventory — how to price seats, manage holds, and work with the map. About a minute.',
      placement: 'center',
    },
    {
      id: 'tabs',
      title: 'Scaling & Inventory',
      target: SEATMAP_TOUR_TARGETS.tabs,
      body: 'Use Scaling first to assign every seat to a price level. Switch to Inventory to manage offers, holds, and kills once pricing is set. Inventory unlocks after all seats are assigned.',
      placement: 'bottom',
    },
    {
      id: 'sidebar',
      title: 'Sidebar',
      target: SEATMAP_TOUR_TARGETS.sidebar,
      body: 'Categories appear here — price levels on Scaling; offers, holds, and kills on Inventory. Select seats on the map, then drag them onto a category or use Move to reassign.',
      placement: 'right',
    },
    {
      id: 'map',
      title: 'The map',
      target: SEATMAP_TOUR_TARGETS.map,
      body: 'Click individual seats to select them. Use the tools on the right to select a full row or section. General admission sections open a seat-count dialog on Inventory.',
      placement: 'left',
    },
    {
      id: 'toolbar',
      title: 'Selection tools',
      target: SEATMAP_TOUR_TARGETS.toolbar,
      body: 'Seat selector picks one seat at a time. Row selector selects an entire row. Section selector selects every seat in a section (or a GA block).',
      placement: 'left',
    },
    {
      id: 'zoom',
      title: 'Zoom & pan',
      target: SEATMAP_TOUR_TARGETS.zoom,
      body: 'Use + and − to zoom, or scroll the mouse wheel over the map. Click and drag on empty space to pan when the map is zoomed in.',
      placement: 'left',
    },
    {
      id: 'nav-actions',
      title: 'Save & exit',
      target: SEATMAP_TOUR_TARGETS.navActions,
      body: 'Back saves your work and returns to the event. Reset clears the current configuration. Save as template stores this layout for other events.',
      placement: 'bottom',
    },
    {
      id: 'done',
      title: "You're set",
      body: 'Open this guide anytime with the help button in the top bar. Changes are saved when you leave the seat map.',
      placement: 'center',
    },
  ]
}
